import React from 'react'
import { Link } from 'react-router-dom';
import Chip from '@mui/material/Chip';
import InfoIcon from '@mui/icons-material/Info';
import InfoModal from './InfoModal';
import StudentHomeworkHistoryModal from './StudentHomeworkHistoryModal';
import TodayOutlinedIcon from '@mui/icons-material/TodayOutlined';
import { tokens } from "../../theme";
import { Box, useTheme } from "@mui/material";
import dayjs from 'dayjs';
import Badge from '@mui/material/Badge';
import { styled } from '@mui/material/styles';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

var options = {
    year: "numeric",
    month: "short",
    day: "numeric"
};

const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
      right: 10,
      top: 3,
      border: `2px solid ${theme.palette.background.paper}`,
      padding: '0 2px',
    },
}));

const EachTableRow = ({ i, index, homeworksLen, homework, StyledTableCell, StyledTableRow, element }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    // for modal
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    
    // for student homework history modal
    const [historyModalOpen, setHistoryModalOpen] = React.useState(false);
    const [selectedStudent, setSelectedStudent] = React.useState(null);
    
    const handleStudentClick = (student) => {
        setSelectedStudent(student);
        setHistoryModalOpen(true);
    };
    
    const handleHistoryModalClose = () => {
        setHistoryModalOpen(false);
        setSelectedStudent(null);
    };

    return (
        <>
        <StyledTableRow>
            <StyledTableCell style={{ width: "10%" }}>
                {dayjs(homework.createdAt).locale('en').format('MMM DD, YYYY')}
            </StyledTableCell>
            {i === 0 && index === 3 ? (
                <StyledTableCell rowSpan={homeworksLen} style={{ backgroundColor: colors.greenAccent[500], width: "14%" }}>
                    <Box sx={{ display: 'flex', alignContent: 'center', gap: '0.5rem' }}>
                        <Box>
                            {new Date(element).toUTCString("en", options).substring(0, 16)}
                        </Box>
                        <Box>
                            <TodayOutlinedIcon />
                        </Box>
                    </Box>
                </StyledTableCell>
            ) : i === 0 && index !== 3 ? (
                <StyledTableCell rowSpan={homeworksLen} style={{ width: "14%" }}>
                    {new Date(element).toUTCString("en", options).substring(0, 16)}
                </StyledTableCell>
            ) : (null)}
            <StyledTableCell component="th" scope="special_note" style={{ width: "10%" }}>
                ({homework.course.code}) {homework.course.course_title}
            </StyledTableCell>
            <StyledTableCell style={{ width: "10%" }}>
                {homework.isTest && (
                    <Chip
                        label="TEST"
                        size="small"
                        color="info"
                        sx={{ mr: "0.3rem", mb: "0.2rem", fontWeight: "bold", fontSize: "0.65rem", height: "20px" }}
                    />
                )}
                {homework.isQbank && (
                    <Chip
                        label="QBANK"
                        size="small"
                        color="secondary"
                        sx={{ mr: "0.3rem", mb: "0.2rem", fontWeight: "bold", fontSize: "0.65rem", height: "20px" }}
                    />
                )}
                {homework.isPrepExam && (
                    <Chip
                        label="EXAM"
                        size="small"
                        color="info"
                        sx={{ mr: "0.3rem", mb: "0.2rem", fontWeight: "bold", fontSize: "0.65rem", height: "20px" }}
                    />
                )}
                {homework.isTest && homework.hasSubmissions && (!homework.hasFrq || homework.frqGradingComplete) && (
                    homework.isV2Test
                        ? <Chip label="GRADED" size="small" color="success" sx={{ mr: "0.3rem", mb: "0.2rem", fontWeight: "bold", fontSize: "0.65rem", height: "20px" }} />
                        : (homework.allHaveApScore
                            ? <Chip label="GRADED" size="small" color="success" sx={{ mr: "0.3rem", mb: "0.2rem", fontWeight: "bold", fontSize: "0.65rem", height: "20px" }} />
                            : <Chip label="NEEDS AP SCORE" size="small" color="warning" sx={{ mr: "0.3rem", mb: "0.2rem", fontWeight: "bold", fontSize: "0.65rem", height: "20px" }} />
                        )
                )}
                <Link
                    to={homework.isTest
                        ? `/classrooms/${homework.course.uuid}/tests`
                        : (homework.isQbank || homework.isPrepExam)
                            ? `/classrooms/${homework.course.uuid}/homework`
                            : `/classrooms/${homework.course.uuid}/homework/${homework.id}`
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: 'inherit', textDecoration: 'none' }}
                    onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                    onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
                >
                    {homework.title}
                </Link>
            </StyledTableCell>
            <StyledTableCell style={{ width: "52%" }}>
                {homework.studentsWhoSubmitted.map((student, index) => {
                    let exclude_students = [];
                                            
                    if (homework.exclude_student !== null) {                            
                        const exclude_student = homework.exclude_student.split('|');
                        exclude_students = exclude_student;
                    }
                    if (exclude_students.includes(student.id.toString()))
                        return null
                    if (homework.feedback_map[student.id] !== undefined) {
                        return (                            
                            <StyledBadge key={index} color='primary' variant={homework.feedback_map[student.id].is_opened ? 'standard' : 'dot'}>
                                {homework.feedback_map[student.id].is_opened &&
                                    <CheckCircleIcon sx={{ position: "absolute", top: "-0.5rem", right: "0", backgroundColor: colors.primary[600], borderRadius: '50%', zIndex: 1 }} />
                                }
                                <Chip 
                                    color='secondary' 
                                    label={student.name} 
                                    sx={{ mr: "0.3rem", mb: "0.3rem", cursor: 'pointer', '&:hover': { opacity: 0.8 } }} 
                                    onClick={() => handleStudentClick(student)}
                                />
                            </StyledBadge>
                        )
                    } else {
                        return (
                            <Chip 
                                key={index} 
                                color='secondary' 
                                label={student.name} 
                                sx={{ mr: "0.3rem", mb: "0.3rem", cursor: 'pointer', '&:hover': { opacity: 0.8 } }} 
                                onClick={() => handleStudentClick(student)}
                            />
                        )
                    }
                })}
                {homework.lateSubmissionStudents.map((student, index) => {
                    let exclude_students = [];
                                            
                    if (homework.exclude_student !== null) {                            
                        const exclude_student = homework.exclude_student.split('|');
                        exclude_students = exclude_student;
                    }

                    if (exclude_students.includes(student.id.toString()))
                        return null
                                        
                    if (homework.feedback_map[student.id] !== undefined) {
                        return (
                            <StyledBadge key={index} color='primary' variant={homework.feedback_map[student.id].is_opened ? 'standard' : 'dot'}>
                                {homework.feedback_map[student.id].is_opened &&
                                    <CheckCircleIcon sx={{ position: "absolute", top: "-0.5rem", right: "0", backgroundColor: colors.primary[600], borderRadius: '50%', zIndex: 1 }} />
                                }
                                <Chip 
                                    color='warning' 
                                    label={student.name} 
                                    sx={{ mr: "0.3rem", mb: "0.3rem", cursor: 'pointer', '&:hover': { opacity: 0.8 } }} 
                                    onClick={() => handleStudentClick(student)}
                                />
                            </StyledBadge>
                        )
                    } else {
                        return (
                            <Chip 
                                key={index} 
                                color='warning' 
                                label={student.name} 
                                sx={{ mr: "0.3rem", mb: "0.3rem", cursor: 'pointer', '&:hover': { opacity: 0.8 } }} 
                                onClick={() => handleStudentClick(student)}
                            />                            
                        )
                    }
                })}
                {homework.studentsWhoDidNotSubmit.map((student, index) => {
                    let exclude_students = [];
                                                
                    if (homework.exclude_student !== null) {                            
                        const exclude_student = homework.exclude_student.split('|');
                        exclude_students = exclude_student;
                    }

                    if (exclude_students.includes(student.id.toString()))
                        return null
                    return <Chip 
                        key={index} 
                        label={student.name} 
                        sx={{ mr: "0.3rem", mb: "0.3rem", cursor: 'pointer', '&:hover': { opacity: 0.8 } }} 
                        onClick={() => handleStudentClick(student)}
                    />
                })}
            </StyledTableCell>
            <StyledTableCell align='center' style={{ width: "4%" }}>
                <div>
                    <InfoIcon 
                        fontSize='medium' 
                        sx={{ cursor: "pointer" }} 
                        onClick={handleOpen}    
                    />
                    <InfoModal 
                        homework={homework} 
                        open={open} 
                        handleClose={handleClose} 
                        StyledTableCell={StyledTableCell}
                        StyledTableRow={StyledTableRow}
                    />
                </div>
            </StyledTableCell>
        </StyledTableRow>
        {selectedStudent && (
            <StudentHomeworkHistoryModal
                open={historyModalOpen}
                handleClose={handleHistoryModalClose}
                student={selectedStudent}
                courseId={homework.course.uuid}
                courseName={`(${homework.course.code}) ${homework.course.course_title}`}
            />
        )}
        </>
    )
}

export default EachTableRow